module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_8004.8e93e242.png";